import React from 'react';
import { type UnitScale } from '../App';
import ExecutiveSummaryPanel from './ExecutiveSummaryPanel';

// ── Insights tab ───────────────────────────────────────────────────────────────
// Launcher shell for the Insights agents. v1 hosts exactly one agent
// (Executive Summary); future agents (e.g. Benchmarking Agent) mount as sibling
// panels here without touching the existing one.
//
// canGenerate gates on authentication: anonymous demo visitors see the seeded
// summary read-only (the backend refuses generation on the demo project and on
// anonymous callers regardless, so this is UX, not a security boundary).
//
// unitScale is accepted for signature parity with the other views and for
// future agents that surface scaled figures; the Executive Summary reads
// pre-formatted display strings from the packet, so it does not need it today.

export default function InsightsView({
  projectId,
  isAuthenticated,
}: {
  projectId: string;
  isAuthenticated: boolean;
  unitScale: UnitScale;
}) {
  return (
    <div className="space-y-4">
      <div className="rounded-lg border border-gray-800 bg-gray-900/40 p-4 md:p-5">
        <ExecutiveSummaryPanel projectId={projectId} canGenerate={isAuthenticated} />
      </div>
    </div>
  );
}
